import { NOTIFICATION_TYPES } from '@vbee-holding/aivoice-shared-lib';
import { actionTypes } from './actions';

const DEFAULT_GROUP_STATE = {
  list: [],
  cursor: '',
  hasMore: true,
  loading: false,
};

export const initialState = {
  hasNewNotification: false,
  unreadStatus: {
    [NOTIFICATION_TYPES.PROMOTION]: false,
    [NOTIFICATION_TYPES.NEWS]: false,
    [NOTIFICATION_TYPES.SYSTEM]: false,
  },
  groups: {},
  activeGroup: null,
  isPanelOpen: false,
};

const getGroupState = (state, groupCode) =>
  state.groups[groupCode] || DEFAULT_GROUP_STATE;

const updateGroup = (state, groupCode, updates) => ({
  ...state,
  groups: {
    ...state.groups,
    [groupCode]: {
      ...getGroupState(state, groupCode),
      ...updates,
    },
  },
});

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_NOTIFICATIONS: {
      const group = getGroupState(state, action.groupCode);
      const isFirstLoad = group.list.length === 0;
      return updateGroup(state, action.groupCode, {
        loading: isFirstLoad,
      });
    }

    case actionTypes.FETCH_NOTIFICATIONS_SUCCESS: {
      const group = getGroupState(state, action.groupCode);
      return updateGroup(state, action.groupCode, {
        loading: false,
        list: action.isLoadMore ? [...group.list, ...action.data] : action.data,
        cursor: action.nextCursor || '',
        hasMore: action.hasMore,
      });
    }

    case actionTypes.FETCH_NOTIFICATIONS_FAILURE:
      return updateGroup(state, action.groupCode, { loading: false });

    case actionTypes.MARK_READ_SUCCESS: {
      const updated = {};
      Object.entries(state.groups).forEach(([groupCode, group]) => {
        updated[groupCode] = {
          ...group,
          list: group.list.map((item) =>
            item.id === action.notificationId
              ? { ...item, readAt: new Date().toISOString() }
              : item,
          ),
        };
      });
      return { ...state, groups: updated };
    }

    case actionTypes.MARK_ALL_READ_SUCCESS: {
      const updated = {};

      Object.entries(state.groups).forEach(([groupCode, group]) => {
        updated[groupCode] = {
          ...group,
          list: group.list.map((item) => ({
            ...item,
            readAt: !action.groupCode ? new Date().toISOString() : item.readAt,
          })),
        };
      });

      const newUnreadStatus = action.groupCode
        ? {
            ...state.unreadStatus,
            [action.groupCode]: false,
          }
        : {
            [NOTIFICATION_TYPES.PROMOTION]: false,
            [NOTIFICATION_TYPES.NEWS]: false,
            [NOTIFICATION_TYPES.SYSTEM]: false,
          };

      return {
        ...state,
        groups: updated,
        unreadStatus: newUnreadStatus,
        hasNewNotification: false,
      };
    }

    case actionTypes.FETCH_UNREAD_STATUS_SUCCESS:
      return {
        ...state,
        unreadStatus: action.unreadStatus,
        hasNewNotification: action.hasNewNotification,
      };

    case actionTypes.RECEIVE_NOTIFICATION: {
      const { groupCode, notification } = action;
      const group = getGroupState(state, groupCode);
      const pinnedItems = group.list.filter((item) => item.isPinned);
      const nonPinnedItems = group.list.filter((item) => !item.isPinned);
      return {
        ...updateGroup(state, groupCode, {
          list: [...pinnedItems, notification, ...nonPinnedItems],
        }),
        unreadStatus: {
          ...state.unreadStatus,
          [groupCode]: true,
        },
        hasNewNotification: true,
      };
    }

    case actionTypes.SET_HAS_NEW_NOTIFICATION:
      return { ...state, hasNewNotification: action.hasNew };

    case actionTypes.SET_ACTIVE_GROUP:
      return { ...state, activeGroup: action.group };

    case actionTypes.SET_PANEL_OPEN:
      return { ...state, isPanelOpen: action.isOpen };

    default:
      return state;
  }
};

export default notificationReducer;
